import {
  formatServiceLineStatus,
  formatServiceSlipLineSummary,
  formatServiceSlipTicketTime,
  getServiceSlipGuestLabel,
} from '@/components/pos/posServiceSlip'

/**
 * @param {object} props
 * @param {import('@/types/api').PosServiceSlips | null} props.document
 */
export function PosServiceSlips({ document }) {
  if (!document?.slips?.length) return null

  return (
    <div className="service-slip-root pointer-events-none fixed -left-[9999px] top-0">
      {document.slips.map((slip, index) => (
        <article
          key={`${slip.label}-${index}`}
          className="service-slip"
          aria-label={`Service slip for ${slip.label}`}
        >
          <header className="service-slip__header">
            <p className="service-slip__title">Service slip</p>
            <p className="service-slip__branch">{document.branch?.name}</p>
          </header>

          <section className="service-slip__meta">
            <p><strong>Stylist</strong> {slip.label}</p>
            <p><strong>Ticket</strong> {document.sale?.sale_number}</p>
            <p><strong>Guest</strong> {getServiceSlipGuestLabel(document)}</p>
            <p><strong>Time</strong> {formatServiceSlipTicketTime(document)}</p>
            <p><strong>Duration</strong> {slip.total_duration_minutes} min</p>
          </section>

          <section className="service-slip__lines">
            {slip.lines.map((line) => (
              <div key={line.id} className="service-slip__line">
                <p className="service-slip__line-title">{formatServiceSlipLineSummary(line)}</p>
                <p className="service-slip__line-status">
                  Status: {formatServiceLineStatus(line.line_status)}
                </p>
                {line.addons?.length ? (
                  <ul className="service-slip__addons">
                    {line.addons.map((addon) => (
                      <li key={addon}>+ {addon}</li>
                    ))}
                  </ul>
                ) : null}
              </div>
            ))}
          </section>

          <footer className="service-slip__footer">
            Hand to stylist before service starts
          </footer>
        </article>
      ))}
    </div>
  )
}
